import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-download\"><path d=\"M11.934 5.524h-1.363V1.238a.86.86 0 0 0-.857-.857H6.286a.86.86 0 0 0-.857.857v4.286H4.066c-.763 0-1.149.926-.609 1.466l3.934 3.934a.854.854 0 0 0 1.209 0l3.934-3.934c.54-.54.163-1.466-.6-1.466zM2 14.095a.86.86 0 0 0 .857.857h10.286a.86.86 0 0 0 .857-.857.86.86 0 0 0-.857-.857H2.857a.86.86 0 0 0-.857.857z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol